import { NewBlockMemberService } from './new-block-member-service';

export default NewBlockMemberService;
